import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessagingFilter, MessagingStatLog, MessagingType } from '../../models/MessagingStatLog';
import { MessagingService } from '../../services/messaging.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FilteringService } from '../../services/filtering.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailErrorDialogComponent } from './email-error-dialog/email-error-dialog.component';
import { SendEmailPacketComponent } from './send-email-packet/send-email-packet.component';
import { PaginationEventData } from '../pagination-top/models/paginationEventData';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';


@Component({
  selector: 'app-email-queue',
  templateUrl: './email-queue.component.html',
  styleUrls: ['./email-queue.component.less']
})
export class EmailQueueComponent implements OnInit, OnDestroy {
  lastKey : any = {
    key : 'timestamp',
    ascending : false
  };
  
  datas : MessagingStatLog[];
  datas$: Subscription;
  resolve$: Subscription;
  filter: MessagingFilter;
  filterApplied: boolean = false;

  @Input() reportId: number;
  @Input() title: string;

  public get customTitle() {
    return this.title ?? "Email Error Queue" 
  }

  
  public get disclosures() : MessagingStatLog[] {
    if(!this.datas) return [];
    else return this.appData.sortByKey(this.datas.filter(e => {return !e.errorResolved && e.messageType == 2;}),this.lastKey.key,this.lastKey.ascending);
  }
  
  
  public get data(): MessagingStatLog[] {
    if(!this.datas) return [];
    else return this.appData.sortByKey(this.datas.filter(e => {return !e.errorResolved && e.messageType == 1;}),this.lastKey.key,this.lastKey.ascending);
  }

  public get resolvedData() : MessagingStatLog[] {
    if(!this.datas) return [];
    else return this.datas.filter(e => e.errorResolved);
  }

  public resolvedDataToDisplay: MessagingStatLog[] = [];

  public get totalRecordsCount() : number {
    if(!this.data) return 1; //otherwise the pagination controls weird out
    else if(this.filterApplied) return this.resolvedDataToDisplay.length;
    else return this.resolvedData.length;
  }
  
  constructor(public mess: MessagingService, 
    public toast: ToastrService, 
    public filtering: FilteringService, 
    public router: Router,
    public auth: AuthService,
    public appData : ApplicantDataService,
    public modalService: NgbModal) {
    
  }
  ngOnDestroy(): void {
    if(this.datas$) this.datas$.unsubscribe();
    this.filter = null;
  }

  ngOnInit(): void {

      this.filter = new MessagingFilter();
      this.datas$ = this.mess.fetchEmailErrorLogs().pipe(tap((_: MessagingStatLog[]) => {
        this.datas = _;
      },
      e => {
        this.toast.error('Error fetching email logs', '', { closeButton: true, disableTimeOut: true });
      },
      () => {
        this.resetVisibleData();
      })).subscribe();
    
  }

  onPaginationChanged(pageEvent: PaginationEventData) {
    if(this.filterApplied) {
      this.resolvedDataToDisplay = this.resolvedDataToDisplay.slice(pageEvent.offset, pageEvent.offset + 50);
    } else {
      this.resolvedDataToDisplay = this.resolvedData.slice(pageEvent.offset, pageEvent.offset + 50);
    }
  }

  fireDisclosure(err: MessagingStatLog){
    let ovrd = {
      ovrd_email : this.auth.loggedInUser.email,
      msg : err
    };
    console.log(ovrd);
    this.appData.FireOffConsumerDisclosureEmail2(ovrd).subscribe(
      (scs: any) => {
        this.toast.success('Disclosure Sent to Applicant');
      },
      (err: any) => {
        this.toast.error('Disclosure Send Failed');
      },()=>{
      }
    );

  }

  public resolveErrorDialog(err: MessagingStatLog) {
    let mod = this.modalService.open(EmailErrorDialogComponent, { centered: true, size: 'lg' });
    mod.componentInstance.datas = err;
    mod.componentInstance.name = 'ResolveEmailErrorDialog';

  }

  public launchEmailPacketDialog(err: MessagingStatLog) {
    let mod = this.modalService.open(SendEmailPacketComponent, { centered: true, size: 'lg' });
    mod.componentInstance.datas = err;
    mod.componentInstance.name = 'SendPacketDialog';
  }

  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
  }

  public navTo(email: MessagingStatLog) : void {
    this.router.navigateByUrl(`screenings/review/${email.screeningId}`);
  }

  public applyFilters(): void {
    this.resetVisibleData();
    this.filterApplied = true;
    if(this.filter.clientName) {
      this.resolvedDataToDisplay = this.resolvedData.filter(e => e.clientName.toLowerCase().includes(this.filter.clientName.toLowerCase()));
    }

    if(this.filter.reportNumber) {
      this.resolvedDataToDisplay = this.resolvedData.filter(e => e.reportNumber === this.filter.reportNumber);
    }

    if(this.filter.locationName) {
      this.resolvedDataToDisplay = this.resolvedData.filter(e => e.locationName.toLowerCase().includes(this.filter.locationName.toLowerCase()));
    }

  }

  public clearFilters(): void {
    this.filter.clientName = undefined;
    this.filter.reportNumber = undefined;
    this.filter.locationName = undefined;
    this.filterApplied = false;
    this.resetVisibleData();

  }

  private resetVisibleData(): void {
    this.resolvedDataToDisplay = this.resolvedData.splice(0, 50);
  }

}
